import styled from 'styled-components'
import CloseIcon from '@mui/icons-material/Close'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 0 16px;
  border-radius: 50px;
  background-color: ${({ isSelected }) => (isSelected ? '#FBDDD0' : '#f1f3f5')};
  cursor: pointer;
`

const StyledSpan = styled.span`
  display: inline-block;
  white-space: nowrap;
  text-transform: capitalize;
  max-width: ${({ maxTextSize }) => maxTextSize}px;
  text-overflow: ellipsis;
  overflow: hidden;
`

const FilterOption = ({
  name,
  onClick,
  isSelected,
  dismissable,
  maxTextSize,
}) => {
  return (
    <Container
      onClick={onClick}
      isSelected={isSelected}
    >
      <StyledSpan maxTextSize={maxTextSize}>{name}</StyledSpan>
      {dismissable && isSelected && <CloseIcon sx={{ fontSize: 16 }} />}
    </Container>
  )
}

export default FilterOption
